import andatiFestejo from "./GIF_Andatti_RenderSmall.gif"
import andatiPena from "./GIF_Andatti_PenaRenderSmall.gif"
import premiaFestejo from "./GIF_Premia_RenderSmall.gif"
import premiaPena from "./GIF_Premia_PenaRenderSmall.gif"
import spinFestejo from "./GIF_Spin_RenderSmall.gif"
import spinPena from "./GIF_Spin_PenaRenderSmall.gif"
import celFestejo from "./GIF_Cel_RenderSmall.gif"
import celPena from "./GIF_Cel_PenaRenderSmall.gif"

export const assetGifCharacter = {
	andatti: {
		festejo: andatiFestejo,
		pena: andatiPena
	},

	premia: {
		festejo: premiaFestejo,
		pena: premiaPena
	},
	spin: {
		festejo: spinFestejo,
		pena: spinPena
	},
	cel: {
		festejo: celFestejo,
		pena: celPena
	},
}